import { concat, uniq } from 'ramda';

export function mergeTermsValue<T>({ oldTerms, newTerms }: { oldTerms: Array<T>; newTerms: Array<T> }) {
  return uniq(concat(oldTerms, newTerms));
}
